import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Section, cellCls } from "@/components/account/Shell";
import { Cell, Dash, Sheet, Two, Txt } from "@/components/account/Sheet";
import api, { formatApiError } from "@/lib/api";
import { when } from "@/lib/when";

const SVC_COLS = [
    { key: "when", label: "Received", sub: "date · how long ago", w: "150px" },
    { key: "type", label: "Request", sub: "type · machine", w: "minmax(180px,1.1fr)" },
    { key: "who", label: "Who", sub: "name · email · phone · where", w: "minmax(220px,1.3fr)" },
    { key: "details", label: "Details", sub: "their words · preferred date", w: "minmax(260px,2fr)" },
    { key: "status", label: "Status", sub: "change it here", w: "140px" },
];


export const ServiceRequests = () => {
    const [rows, setRows] = useState([]);
    const load = () => api.get("/admin/marketplace/service-requests").then(({ data }) => setRows(data.requests)).catch(() => {});
    useEffect(() => { load(); }, []);
    const setStatus = async (id, status) => {
        try { await api.post(`/admin/marketplace/service-requests/${id}/status?status=${status}`); load(); }
        catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    };
    const fresh = rows.filter((s) => s.status === "new").length;

    return (
        <Section title={`${rows.length} service requests · ${fresh} new`} pad={false} testid="mp-services" note="install · repair · maintenance · training">
            <Sheet cols={SVC_COLS} rows={rows} rowKey={(s) => s.id} testid="mp-services-sheet" minWidth={980}
                empty="No service requests yet." rowTestid={(s) => `service-row-${s.id}`}
                cells={(s) => ({
                    when: <Cell><Txt sub>{when(s.created_at)}</Txt></Cell>,
                    type: <Cell><Two a={s.type} b={s.machine} /></Cell>,
                    who: <Cell><Two a={s.name} b={[s.email, s.phone, s.location].filter(Boolean).join(" · ")} /></Cell>,
                    details: <Cell>{s.details || s.preferred_date
                        ? <Txt sub title={s.details}>{[s.details, s.preferred_date && `wants ${s.preferred_date}`].filter(Boolean).join(" · ")}</Txt>
                        : <Dash why="No details written" />}</Cell>,
                    status: (
                        <Cell>
                            <select value={s.status} onChange={(e) => setStatus(s.id, e.target.value)} data-testid={`mp-service-status-${s.id}`}
                                className={`${cellCls} w-full py-px text-left text-[11px] font-semibold`}>
                                {["new", "scheduled", "done", "cancelled"].map((x) => <option key={x} value={x}>{x}</option>)}
                            </select>
                        </Cell>
                    ),
                })} />
        </Section>
    );
};
